import React from 'react';
import style from './componentCss/PopUpPage.module.css';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const PopUpPage = ({ type, value, cancelPopUpPage }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: function(index) {},
    beforeChange: (current, next) => {},
  };

  return (
    <div className={style.container}>
      <div className={`${style.container__PopUpPage} ${style[type]}`}>
        <div className={style.container__PopUpPage__container}>
          <div className={style.container__PopUpPage__header}>
            <div className={style.container__PopUpPage__header__title}>
              <p>{value.title}</p>
            </div>
          </div>

          <div className={style.container__PopUpPage__body}>
            <Slider {...settings}>
              {value.imgSrc.map((imgSrc, index) => (
                <div key={index} className={`${style.container__PopUpPage__body__img} ${style[type]}`}>
                  <img src={imgSrc} alt="" />
                </div>
              ))}
            </Slider>

            {type === 'CoworkersPopUp' ? (
              <>
                {value.longParaGraph.map((paraGraph, index) => (
                  <p key={index} className={style.container__PopUpPage__CoworkersPopUp__paraGraph}>{paraGraph}</p>
                ))}
                {value.contactField.map((contact, index) => (
                  <div key={index} className={style.container__PopUpPage__CoworkersPopUp__contact}>
                    <a href={contact}>{contact}</a>
                  </div>
                ))}
              </>
            ) : (
              value.longParaGraph.map((paraGraph, index) => (
                <p key={index} className={style.container__PopUpPage__NewsRoomCardPopUp}>{paraGraph}</p>
              ))
            )}
          </div>
        </div>
      </div>

      <div className={style.container__PopUpPage__background} onClick={cancelPopUpPage}></div>
    </div>
  );
};

export default PopUpPage;
